module.exports = __webpack_public_path__ + "img/insert.5f10babd.png";